module.exports = __webpack_public_path__ + "static/media/999_grey.caaf327b.svg";